import { shape, string } from 'prop-types'
export const UserPropType = shape({
  name: string.isRequired,
  email: string.isRequired
})
